import CrudRepository from './CrudRepository'
export default class RoamingRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/serviceManagement/type/2')
  }
}
